exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".black{color:#fff;height:50px;font-size:20px;font-weight:700}.black1{line-height:40px;font-size:18px}", ""]);

// exports
